export default {
    get_application_user: state => { return state['satabapp-user']},
    get_application_company: state => { return state['satabapp-company']},
    get_application_token: state => { return state['satabapp-token']},
    get_application_customer: state => { return state['satabapp-customer']},
    get_application_translation: state => { return state['satabapp-translation']}
};